<template>
  <section class="supporter-section">
    <h2>ผู้สนับสนุน</h2>
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-auto">
          <img src="@/assets/logo/kasetsart-vet.png" alt="kasetsart logo">
        </div>
        <div class="col-md-auto">
          <img src="@/assets/logo/iTaam-logo.jpg" alt="iTaam logo">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'SupporterSection',
  components: {
    Container
  }
}
</script>

<style scoped lang="scss">
.supporter-section {
  padding: 2rem;
  h2 {
    text-align: center;
    color: $gray-600;
    font-size: $h6-font-size;
    margin-bottom: 2rem;
  }
  img {
    filter: grayscale(100%);
    height: 10rem;
    opacity: 0.6;
    margin: auto;
    display: block;
    margin-bottom: 1rem;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .supporter-section {
    h2 {
      font-size: $h5-font-size;
    }
  }
}
</style>
